import FallbackImage from '../../../components/generic/FallbackImage';
import Text from '../../../components/generic/Text';

const EmptyFossaAnalysisState = () => {
  return (
    <FallbackImage src="no-results" alt="no published reports">
      <Text.Heading>FOSSA analysis is not available.</Text.Heading>
    </FallbackImage>
  );
};

export default EmptyFossaAnalysisState;
